import { fetchAgencies } from './fetchAgencies'

export const agencies = {
  index() {
    return fetchAgencies()
  },
}
